module.exports = __webpack_public_path__ + "static/media/vehicle-marker.4a8c386e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vehicle-marker.svg
// module id = 243
// module chunks = 0